import React from "react";
import { Accordion } from "react-bootstrap";
import { useSelector } from "react-redux";
import { isInDevelopment, versionDate } from "../../config";
import Auth from "../../helpers/auth";
import { translate } from "../Language/Translate";
import CardSqlArea from "./CardSqlArea";
import CardTextbausteinArea from "./CardTextbausteinArea";
import InitFields from "./InitFields";
import TestArea from "./TestArea";
import { simpleRequest } from "../../newForms2/simpleRequest";
// import SqlField from "./SqlField";

const AdminArea = () => {
  const currentUser = useSelector(st => st.currentUser);
  const auth = Auth.getAll(currentUser.userStatus, currentUser.companyId);
  if(!Auth.isMainAdmin(currentUser?.userStatus))return null

  // const handleClick=async()=> {
  //   const response = await simpleRequest({url:"admin/testroute", method:"get"})
  //   console.log({response})
  // }

  return (
    <div className="p-5 text-center" style={{ border: "1px solid black", borderRadius: "5px" }}>
      {isInDevelopment && <TestArea />}
      <h4>{translate("Admin Area")}</h4>
      <p>Version {versionDate}</p>
      {/* <button className="btn btn-outline-dark" onClick={handleClick}>Test</button> */}
      {Auth.isDeveloper(currentUser.userStatus) && isInDevelopment ? <InitFields /> : null}
      {/* <InitFields/> */}
      <Accordion style={{ backgroundColor: "#e5e9df", borderRadius: "5px" }}>




        {auth.isDeveloper && <CardSqlArea eventKey="12" />}
        {auth.isMainAdmin && <CardTextbausteinArea eventKey="13" />}
      </Accordion>
    </div>
  );
};
export default AdminArea;
